import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { supabase } from '../lib/supabase.ts';
import { useAuth } from '../lib/auth.tsx';
import Button from './Button.tsx';

export default function AppShell({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  async function signOut() {
    await supabase?.auth.signOut();
  }

  return (
    <div className="min-h-screen">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <header className="border-b border-border bg-surface">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-6 py-4">
          <Link to="/app" className="font-serif text-xl text-ink">
            Austin OS
          </Link>
          <nav aria-label="App" className="flex items-center gap-5 text-sm">
            <NavLink
              to="/app"
              className={({ isActive }) => (isActive ? 'text-ink' : 'text-ink-muted')}
              end
            >
              Experiments
            </NavLink>
            <NavLink
              to="/app/experiments/new"
              className={({ isActive }) => (isActive ? 'text-ink' : 'text-ink-muted')}
            >
              New experiment
            </NavLink>
            <span className="hidden text-ink-subtle sm:inline">{user?.email}</span>
            <Button tone="quiet" onClick={() => void signOut()}>
              Sign out
            </Button>
          </nav>
        </div>
      </header>
      <div id="main">{children}</div>
    </div>
  );
}
